/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  KsuCompany,
  KsuCompanyWellContainers,
  KsuField,
  KsuFieldQueryParameters,
  KsuFieldWithGlobalWells,
  KsuLicenseArea,
  SearchWellGroupsParameters,
  SearchWellsParameters,
  WellGroup,
  WellSearchResult,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class KsuWellsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
 * No description
 * 
 * @tags KsuWells
 * @summary Поиск скважин и формирование групп с количеством найденных скважин.
Группы могут быть дополнительным критерием при поиске отдельных скважин.
Группировать можем по ДО, месторождениям или ЛУ.
 * @request POST:/geology/KsuWells/SearchWellGroups
 * @secure
 */
  ksuWellsSearchWellGroups = (data: SearchWellGroupsParameters, params: RequestParams = {}) =>
    this.http.request<WellGroup[], any>({
      path: `/geology/KsuWells/SearchWellGroups`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * @description Поиск с пустыми параметрами вернёт вообще все скважины ksu, но очень не скоро!
   *
   * @tags KsuWells
   * @summary Поиск скважин по универсальной строке. Без группировки.
   * @request POST:/geology/KsuWells/SearchWells
   * @secure
   */
  ksuWellsSearchWells = (data: SearchWellsParameters, params: RequestParams = {}) =>
    this.http.request<WellSearchResult[], any>({
      path: `/geology/KsuWells/SearchWells`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags KsuWells
   * @summary Вернёт все дочерние общества в БД ksu-nsi, доступные текущему пользователю
   * @request GET:/geology/KsuWells/GetAllCompanies
   * @secure
   */
  ksuWellsGetAllCompanies = (params: RequestParams = {}) =>
    this.http.request<KsuCompany[], any>({
      path: `/geology/KsuWells/GetAllCompanies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags KsuWells
 * @summary Вернёт доступные пользователю ksu-nsi непустые месторождения.
Возможно запросить количество глобальных скважин.
 * @request POST:/geology/KsuWells/GetFields
 * @secure
 */
  ksuWellsGetFields = (data: KsuFieldQueryParameters, params: RequestParams = {}) =>
    this.http.request<KsuFieldWithGlobalWells[], any>({
      path: `/geology/KsuWells/GetFields`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags KsuWells
   * @summary Вернёт все ksu-nsi месторождения заданного дочернего общества
   * @request GET:/geology/KsuWells/GetFieldsByCompany/{companyKsuId}
   * @secure
   */
  ksuWellsGetFieldsByCompany = (companyKsuId: string, params: RequestParams = {}) =>
    this.http.request<KsuField[], any>({
      path: `/geology/KsuWells/GetFieldsByCompany/${companyKsuId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags KsuWells
   * @summary Вернёт все ksu-nsi лицензионные участки заданного дочернего общества
   * @request GET:/geology/KsuWells/GetLicenseAreasByCompany/{companyKsuId}
   * @secure
   */
  ksuWellsGetLicenseAreasByCompany = (companyKsuId: string, params: RequestParams = {}) =>
    this.http.request<KsuLicenseArea[], any>({
      path: `/geology/KsuWells/GetLicenseAreasByCompany/${companyKsuId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags KsuWells
   * @summary Вернёт все ksu-nsi месторождения заданного дочернего общества
   * @request GET:/geology/KsuWells/GetCompanyWellContainers/{companyKsuId}
   * @secure
   */
  ksuWellsGetCompanyWellContainers = (companyKsuId: string, params: RequestParams = {}) =>
    this.http.request<KsuCompanyWellContainers, any>({
      path: `/geology/KsuWells/GetCompanyWellContainers/${companyKsuId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
